/* Flamingo 2.0: menu drawer, scroll buttons, product variant picker and Book Now links. No jQuery. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // Menu drawer
  var drawer = $('#drawer');
  function toggleDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    document.documentElement.classList.toggle('lock', open);
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
    if (open) { var f = $('a,button', drawer); if (f) f.focus(); }
  }
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { toggleDrawer(true); }); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { toggleDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggleDrawer(false); });

  // Close the desktop services dropdown when clicking elsewhere
  document.addEventListener('click', function (e) {
    $$('.nav details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  // Prev/next buttons on swipe rows
  $$('[data-scroll]').forEach(function (b) {
    b.addEventListener('click', function () {
      var row = document.getElementById(b.getAttribute('data-scroll'));
      if (!row) return;
      var step = row.firstElementChild ? row.firstElementChild.getBoundingClientRect().width + 20 : 300;
      row.scrollBy({ left: b.hasAttribute('data-prev') ? -step : step, behavior: 'smooth' });
    });
  });

  // Quantity steppers
  $$('[data-qty]').forEach(function (w) {
    var i = $('input', w);
    $$('button', w).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(i.value, 10) || 1) + (b.hasAttribute('data-minus') ? -1 : 1));
        i.value = v;
      });
    });
  });

  // Product page
  $$('[data-product]').forEach(function (root) {
    var data = JSON.parse($('[data-product-json]', root).textContent);
    var form = $('form[data-buy]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var bookBtns = $$('[data-book]');
    var atc = $('[data-atc]', root);
    var sbPrice = $('[data-sb-price]');

    var map = {};
    if (data.outlink && data.outlink.variants) {
      try { map = typeof data.outlink.variants === 'string' ? JSON.parse(data.outlink.variants) : data.outlink.variants; } catch (e) { map = {}; }
    }

    function money(c) {
      var n = (c / 100);
      return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
    }
    function current() {
      var opts = $$('fieldset[data-option]', root).map(function (fs) {
        var c = $('input:checked', fs); return c ? c.value : null;
      });
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === null || o === opts[i]; });
      })[0];
    }
    function bookUrl(v) {
      var m = v && map[String(v.id)];
      if (m && m.external_url && data.outlink.outpage !== 1) return m.external_url;
      return data.outlink ? data.outlink.url : '';
    }
    function update() {
      var v = current();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (sbPrice) sbPrice.textContent = money(v.price);
      if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      var url = bookUrl(v);
      var m = map[String(v.id)];
      bookBtns.forEach(function (b) {
        b.setAttribute('data-url', url); b.setAttribute('data-variant', v.id);
        if (m && m.button_text && data.outlink.outpage !== 1) b.textContent = m.button_text;
      });
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? atc.getAttribute('data-label') : atc.getAttribute('data-sold'); }
      if (history.replaceState && data.variants.length > 1) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
    $$('fieldset[data-option] input', root).forEach(function (i) { i.addEventListener('change', update); });
    update();

    // Same behaviour as the live theme's outlink button: go to the variant's Mangomint link and log OutlinkClick.
    bookBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-url') || data.outlink.url;
        if (!url || url === 'http://' || url === 'https://') return;
        try {
          if (data.outlink.ga && typeof window.gtag === 'function') {
            window.gtag('event', data.outlink.outpage === 1 ? 'View' : 'Click', { event_category: 'Outlink', event_label: data.outlink.outpage === 1 ? 'Outlink-View' : 'Outlink-Click', value: url });
          }
          if (data.outlink.fb && typeof window.fbq === 'function') {
            if (data.outlink.outpage === 1) window.fbq('trackCustom', 'OutlinkView', { MultipleLinkPage: url });
            else window.fbq('trackCustom', 'OutlinkClick', { ExternalLink: url });
          }
        } catch (e) {}
        // Give the pixel a moment to send before leaving the page.
        setTimeout(function () { window.location.href = url; }, 150);
      });
    });

    // Sticky mobile bar appears once the main button scrolls out of view
    var bar = $('[data-stickybar]');
    var anchor = $('[data-sticky-anchor]', root);
    if (bar && anchor && 'IntersectionObserver' in window) {
      document.body.classList.add('pad-bar');
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(anchor);
    }
  });

  // Home page sticky bar: show after the hero
  var hb = $('[data-home-bar]'), hero = $('[data-hero]');
  if (hb && hero && 'IntersectionObserver' in window) {
    document.body.classList.add('pad-bar');
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { hb.classList.toggle('show', !e.isIntersecting); });
    }).observe(hero);
  }

  // Hero intro video: play only the one that is visible (wide on desktop, vertical on phones)
  function heroVideo() {
    $$('[data-hero-video]').forEach(function (v) {
      if (v.offsetParent !== null) { v.preload = 'auto'; v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!v.paused) v.pause();
    });
  }
  heroVideo();
  window.addEventListener('resize', heroVideo);

  // Collection sort
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
    });
  });
})();
